var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabordericon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_954_1722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0115 14.3763L22.929 12.0224L22.5366 11.3695C22.3201 11.0091 21.852 10.8922 21.4914 11.1089L18.8797 12.6781C18.5193 12.8946 18.4024 13.3628 18.6191 13.7233L19.0115 14.3763ZM34.771 28.777C34.5527 28.4175 34.084 28.3027 33.7244 28.5211L29.4735 31.1033C29.6757 31.5883 29.8072 32.1088 29.8564 32.6532L34.5151 29.8231C34.8751 29.6048 34.9893 29.1366 34.771 28.777ZM30.6406 35.4766H28.3554V33.1407C28.3554 31.0406 26.6469 29.3321 24.5469 29.3321C22.4468 29.3321 20.7383 31.0406 20.7383 33.1407V35.4766H18.4531C18.0325 35.4766 17.6914 35.8176 17.6914 36.2383C17.6914 36.659 18.0325 37 18.4531 37H30.6406C31.0613 37 31.4023 36.659 31.4023 36.2383C31.4023 35.8176 31.0613 35.4766 30.6406 35.4766ZM24.5469 33.9024C24.1262 33.9024 23.7851 33.5613 23.7851 33.1407C23.7851 32.72 24.1262 32.379 24.5469 32.379C24.9675 32.379 25.3086 32.72 25.3086 33.1407C25.3086 33.5613 24.9675 33.9024 24.5469 33.9024ZM18.8826 17.1197L19.6861 18.457L21.3108 17.4746C23.2367 16.3101 25.7196 16.9591 26.8624 18.827C28.0385 20.7497 27.422 23.258 25.4881 24.4161L23.8546 25.3945L24.375 26.2606C24.5926 26.6226 25.0627 26.7377 25.4225 26.5198L26.0864 26.1208L27.2551 28.0658C27.4721 28.427 27.9408 28.5425 28.3003 28.3264L30.912 26.7571C31.2726 26.5404 31.3892 26.0725 31.1726 25.7119L30.004 23.767L30.6436 23.3827C31.0042 23.166 31.1208 22.698 30.9042 22.3374C30.886 22.3071 25.4068 13.1867 25.3868 13.1576C25.1588 12.8257 24.7118 12.7286 24.3666 12.936L19.1432 16.0744C18.7826 16.2911 18.6659 16.7591 18.8826 17.1197Z",
    fill: "#7225EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2148 33.1417C19.2148 31.651 19.83 30.3016 20.8193 29.3331H19.9766C18.7165 29.3331 17.6914 28.3079 17.6914 27.0479C17.6914 25.7879 18.7165 24.7628 19.9763 24.7628L21.734 24.7635C21.8718 24.7635 22.0071 24.7261 22.1254 24.6552L24.7054 23.1101C25.9119 22.3876 26.2967 20.8226 25.5629 19.623C24.8393 18.4402 23.2854 18.0619 22.0991 18.7791L19.7579 20.1949C16.0785 20.3104 13.1211 23.3402 13.1211 27.0479C13.1211 30.5706 15.7919 33.4807 19.2148 33.8608V33.1417Z",
    fill: "#7225EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_954_1722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabordericon2);
export default __webpack_public_path__ + "static/media/labordericon2.8ebd449717c00e19ac6ec83bd1b23133.svg";
export { ForwardRef as ReactComponent };